import { useEffect } from 'react';

export interface IOutsideDialogClose {
	dialogRef: React.RefObject<HTMLDivElement | HTMLDialogElement | null>;
	callBackFunction: () => void;
}

export const useOutsideDialogClose = (props: IOutsideDialogClose): void => {
	const { dialogRef, callBackFunction } = props;

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent): void => {
			const target = event.target as HTMLElement;

			if (target.closest('.pac-container')) {
				return;
			}

			if (dialogRef.current && !dialogRef.current.contains(target)) {
				callBackFunction();
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return (): void => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [dialogRef, callBackFunction]);
};
